import type { TrialPhase } from './types';

/**
 * Maps days remaining in a trial to a visual phase.
 * Positive = days left, 0 and negative = trial ended (grace or hard stop).
 */
export const getTrialPhase = (daysRemaining: number): TrialPhase => {
  if (daysRemaining > 14) {
    return 'active_safe';
  }
  if (daysRemaining >= 7) {
    return 'active_warning';
  }
  if (daysRemaining >= 1) {
    return 'active_critical';
  }
  if (daysRemaining >= -7) {
    return 'grace_period';
  }
  return 'hard_stop';
};

/**
 * Formats days remaining as "X day(s)".
 */
export const formatDaysRemaining = (daysRemaining: number): string =>
  `${daysRemaining} day${daysRemaining !== 1 ? 's' : ''}`;
